export const dataHooks = {
  tableListItemValue: 'tableListItem-value',
  tableListItemCheckbox: 'tableListItem-checkbox',
  tableListItemCheckboxContainer: 'tableListItem-checkboxContainer',
  tableListItemOptionsContainer: 'tableListItem-optionsContainer',
  tableListItemDragHandle: 'tableListItem-dragHandle',
  tableListItemExpandHandleContainer: 'tableListItem-expandHandleContainer',
  tableListItemExpandHandle: 'tableListItem-expandHandle',
};
